<template>
  <div style="font-size: 24px">会议评分系统</div>
</template>

<script lang="ts" setup></script>
